<div class="main-layout-container">
  <div class="sidebar">
    <app-sidebar
      #sidebar
      (logoutRequest)="showLogoutConfirmation()"
      (sidebarToggled)="onSidebarToggle($event)"
    />
  </div>

  <div class="main-content">
    @if(router.url === '/home') {
    <app-profile />
    }
    <div class="main-content-container">
      <router-outlet />
    </div>
  </div>

  <!-- Overlay para cuando el sidebar está expandido en móvil -->
  <div
    class="sidebar-overlay"
    [class.active]="sidebar.isExpanded"
    (click)="sidebar.toggleSidebar()"
  ></div>
</div>

<app-ext-modal
  [visible]="logoutModalVisible"
  [title]="'Cerrar sesión'"
  [paragraph]="'¿Estás seguro que deseas cerrar la sesión?'"
  [type]="'dude'"
  [confirmText]="'Confirmar'"
  [cancelText]="'Cancelar'"
  (onConfirm)="logout()"
  (onCancel)="logoutModalVisible = false"
  (onClose)="logoutModalVisible = false"
></app-ext-modal>
